const TextColorIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
    <defs>
      <linearGradient id="tc-rainbow" x1="0" y1="0" x2="1" y2="0">
        <stop offset="0%" stopColor="#FF3B30" />
        <stop offset="20%" stopColor="#FF9500" />
        <stop offset="40%" stopColor="#FFCC00" />
        <stop offset="60%" stopColor="#34C759" />
        <stop offset="80%" stopColor="#007AFF" />
        <stop offset="100%" stopColor="#AF52DE" />
      </linearGradient>
    </defs>
    {/* A glyph */}
    <path
      d="M3.5 13.5 L7.5 3.5 L9 3.5 L13 13.5 H11.5 L10.4 10.5 H7.1 L6 13.5 H3.5Z M7.6 9.2 H9.9 L8.75 5.8 L7.6 9.2Z"
      fill="currentColor"
    />
    {/* Rainbow bar */}
    <rect x="2" y="15.5" width="14" height="2" rx="1" fill="url(#tc-rainbow)" />
  </svg>
);

export default TextColorIcon;
